import { IApi } from '../../../api'
import { createRequestTypes } from '../../../helpers/helpers'
import { createAction } from '../../types'

export const prefix = 'atlasai/workflows'

export const LIST_WORKFLOWS = createRequestTypes(prefix, 'LIST_WORKFLOWS')
export const [LIST_WORKFLOWS_REQUEST, LIST_WORKFLOWS_SUCCESS, LIST_WORKFLOWS_FAILURE] =
  LIST_WORKFLOWS

export const listWorkflows = createAction((params?: object) => ({
  type: LIST_WORKFLOWS,
  promise: (api: IApi) => api.atlasAI.listWorkflows(params),
  params,
}))
